export { default } from "./WhatYouShouldKnow";
